const API_BASE = import.meta.env.VITE_API_URL || '';

export async function createRoom(playerId, playerName, pack) {
  const res = await fetch(`${API_BASE}/api/rooms`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ playerId, playerName, pack }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Could not create room');
  return data;
}

export async function uploadProof(code, playerId, dataUrl) {
  const blob = await dataUrlToBlob(dataUrl);
  const res = await fetch(`${API_BASE}/api/rooms/${code}/proof?playerId=${encodeURIComponent(playerId)}`, {
    method: 'POST',
    headers: { 'Content-Type': 'image/jpeg' },
    body: blob,
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Could not upload photo');
  return data.url.startsWith('http') ? data.url : `${API_BASE}${data.url}`;
}

async function dataUrlToBlob(dataUrl) {
  const res = await fetch(dataUrl);
  return res.blob();
}

export function wsUrl(code) {
  const base = API_BASE || `${location.protocol}//${location.host}`;
  const url = new URL(base);
  url.protocol = url.protocol === 'https:' ? 'wss:' : 'ws:';
  url.pathname = `/ws/${code}`;
  return url.toString();
}
